<template>
    <div class="apple-pay-container">
        <PuSkeleton v-if="loading" height="45px" width="300px"></PuSkeleton>
        <a href="javascript:;" class="btn" @click.prevent="sendApplePayPaymentRequest"
           v-if="isApplePayAvailable && !loading">
            <img src="/wmt/images/apple_pay.svg" alt="Pay with Apple Pay"/>
        </a>
    </div>
</template>

<script>
    import paymentMethodMixin from "@mixins/paymentMethodMixin";
    import CheckoutApi from '@support/checkoutApi'
    import applePayApi from "@support/applePayApi";

    export default {
        name: 'authorizeNetApplePay',
        mixins: [paymentMethodMixin],
        data: function () {
            return {
                applePaySession: null,
                isApplePayAvailable: false,
                selectedShippingMethod: {
                    service_code: null,
                    package_code: null
                },
                loading: false,
                deviceData: null
            };
        },
        computed: {
            merchantId() {
                return this.paymentMethod.public.merchantId || null;
            },
        },
        created: function () {
            this.loadApplePay();
        },
        methods: {
            loadApplePay: function () {
                if (!window.ApplePaySession || !ApplePaySession.supportsVersion(3) || !ApplePaySession.canMakePayments() || !this.merchantId) {
                    console.debug("[authorize.net] Apple pay is not supported")
                    this.handlePaymentIsNotSupported();
                    return;
                }

                this.loading = true;
                applePayApi.setInstance(this)

                ApplePaySession.canMakePaymentsWithActiveCard(this.merchantId)
                    .then((canMakePayments) => {
                        this.isApplePayAvailable = canMakePayments;
                        if (canMakePayments !== true) {
                            console.log(`Apple Pay not available in this browser`);
                            this.handlePaymentIsNotSupported();
                        } else {
                            console.log('apple pay is available', canMakePayments);
                        }

                        this.loading = false;
                    });
            },
            sendApplePayPaymentRequest: function () {
                this.applePaySession = new ApplePaySession(3, applePayApi.getDefaults());
                this.applePaySession.onvalidatemerchant = (e) => this.onValidateMerchant(e);
                this.applePaySession.onpaymentmethodselected = (e) => applePayApi.onPaymentMethodSelected(e);
                this.applePaySession.onshippingcontactselected = (e) => applePayApi.onShippingContactSelected(e);
                this.applePaySession.onshippingmethodselected = (e) => applePayApi.onShippingMethodSelected(e);
                this.applePaySession.onpaymentauthorized = (e) => this.onPaymentAuthorized(e);
                this.applePaySession.oncancel = (e) => applePayApi.onCancel(e);
                this.applePaySession.begin();
            },
            onValidateMerchant(event) {
                CheckoutApi.validateAuthorizeNetApplePay(event.validationURL).then((response) => {
                    this.applePaySession.completeMerchantValidation(response.data);
                }).catch(() => {
                    this.setRequestStatus(false);
                    this.applePaySession.abort();
                });
            },
            onPaymentAuthorized(event) {
                this.deviceData = {
                    dataDescriptor: 'COMMON.APPLE.INAPP.PAYMENT',
                    dataValue: window.btoa(JSON.stringify(event.payment.token.paymentData)),
                }

                applePayApi.onPaymentAuthorized(event, {});
            },
        }
    };
</script>
